import { getMailOptionsCategories } from '@/API/repositories/mailCategory';
import { Colors } from '@/common/colors/colors';
import Loading from '@/common/components/Loading';
import PopUp from '@/common/components/PopUp';
import SelectInput from '@/common/components/SelectInput';
import ActionButton from '@/common/components/buttons/ActionButton';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import { useRequestsContext } from '@/common/hooks/requestHook';
import React, { useEffect, useState } from 'react';
import { Form } from './SendAnyMail.styled';

const SendAnyMail = ({
	setShowSendAnyMail,
	handleSendAnyMailTemplate,
	showSendAnyMail,
}) => {
	const [mailCategories, setMailCategories] = useState([]);
	const [selectedCategory, setSelectedCategory] = useState();
	const [accepted, setAccepted] = useState();

	const { hasUnfilledRequest, makeRequest } = useRequestsContext();

	const loadMailCategories = async () => {
		const payload = {
			product: showSendAnyMail.product,
		};
		const res = await makeRequest(getMailOptionsCategories.bind(null, payload));

		if (res.data) {
			const options = res.data.map((d) => ({ label: d.name, value: d._id }));

			setMailCategories(() => options);
			setSelectedCategory(() => options[0]);
		}
	};

	const handleSend = () => {
		handleSendAnyMailTemplate(
			selectedCategory.label.split('_').slice(1, -1).join('_') + '_',
		);
	};

	useEffect(() => {
		loadMailCategories();
	}, []);

	return (
		<>
			{hasUnfilledRequest(getMailOptionsCategories) && <Loading />}
			<PopUp setShow={setShowSendAnyMail}>
				<Form
					onSubmit={(e) => {
						e.preventDefault();
						setAccepted(true);
					}}
				>
					<SelectInput
						showLabel={false}
						options={mailCategories}
						selected={selectedCategory}
						setSelected={setSelectedCategory}
					/>
					<SubmitButton style={{ marginBottom: '-30px' }} text={'Send Mail'} />
				</Form>
			</PopUp>
			{accepted && (
				<PopUp setShow={setAccepted}>
					<div>
						<div>
							Are you sure that you want to send{' '}
							{selectedCategory.label.split('_').slice(1, -1).join('_')} mail.
						</div>
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
								gap: '20px',
								marginTop: '50px',
							}}
						>
							<ActionButton
								defaultText='No i dont'
								color={Colors.red}
								onClick={() => setAccepted(false)}
							/>
							<ActionButton
								text='Yes i want'
								onClick={() => handleSend(false)}
							/>
						</div>
					</div>
				</PopUp>
			)}
		</>
	);
};

export default SendAnyMail;
